import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Order } from '../types/order';
import { DataFetchError } from '../../utils/ErrorClass';
import { useAuthContext } from '../auth/AuthContext';

const useOrderHistory = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { state } = useAuthContext();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('order')
        .select('*')
        .eq('顧客コード', state.customerId)
        .order('注文日', { ascending: false });

      if (error) {
        throw new DataFetchError(error.message);
      }

      setOrders(data as Order[]);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [state.customerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { orders, loading, error };
};

export default useOrderHistory;
